<template>
  <div class="card mt-2 mb-2 ms-5 me-5">
    <div class="card-body">
      <h4><strong>Especificaciones de la materia prima</strong></h4>
      <div class="table-responsive">
        <table class="mx-auto">
          <tbody>
            <tr>
              <td colspan="2" class="lblform"><strong>Presentación / Norma / Acabado:</strong></td>
              <td colspan="4">
                <select id="profileSpecification" class="form-select avilable-input" v-model="profile"
                  @change="getParameters(profile)">
                  <option selected>Opciones disponibles...</option>
                  <option v-for="profileAv in avilableProfiles" :key="profileAv.id" v-bind:value="profileAv">
                    {{ profileAv }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Nombre Comercial:</strong></td>
              <td colspan="2">
                <select id="profileTradeName" class="form-select avilable-input" v-model="tradeName"
                  @change="getProfileId(tradeName)">
                  <option selected>Opciones disponibles...</option>
                  <option v-for="profileType in profileTypesByTradeName" :key="profileType.id"
                    v-bind:value="profileType.profile_id">
                    {{ profileType.profile_trade_name }}
                  </option>
                </select>
              </td>
              <td class="lblform"><strong>Nombre técnico: </strong></td>
              <td colspan="2" class="inputForm">
                <input id="profileTechnicalName" class="form-control" type="text" readonly v-model="technicalName" />
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>{{ heigthLabel }}: </strong></td>
              <td colspan="2" class="inputForm">
                <input id="profileHeight" class="form-control" type="number" readonly v-model="heigthValue" /><i>mm.</i>
              </td>
              <td class="lblform"><strong>{{ widthLabel }}: </strong></td>
              <td colspan="2" class="inputForm">
                <input id="profileWingWidth" class="form-control" type="number" readonly v-model="widthValue" /><i>mm.</i>
              </td>
            </tr>
            <tr>
              <td v-show="!flagNoneThicknessLabel" class="lblform"><strong>{{ thicknessLabel }}: </strong></td>
              <td v-show="!flagNoneThicknessLabel" class="inputForm">
                <input id="profileSoulThinckness" class="form-control" type="number" readonly
                  v-model="thicknessValue" /><i>mm.</i>
              </td>
              <td class="lblform"><strong>Espesor del ala en <i>mm</i>: </strong></td>
              <td class="inputForm">
                <input id="profileWingThinckness" class="form-control" type="number" readonly
                  v-model="thicknessWingValue" /><i>mm.</i>
              </td>
              <td class="lblform"><strong>Peso por metro: </strong></td>
              <td class="inputForm">
                <input id="profileWeigthMeter" class="form-control" type="number" readonly
                  v-model="weightMeterValue" /><i>kg.</i>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="mx-auto">
          <tbody>
            <tr>
              <td colspan="2" class="lblform">
                <strong>Precio por kilo del perfil:</strong>
              </td>
              <td class="inputForm">
                <input type="number" readonly class="form-control" id="profileKiloPrice" v-model="profileKiloPrice"
                  @change="sendKiloPrice()" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  props: {
    getImgInfo: Object,
  },
  watch: {
    getImgInfo(newVal) {
      if (newVal !== null) {
        this.defineProfileNameByImg();
      }
    },
  },
  data() {
    return {
      //Nombre y id de la materia prima principal
      //Según el id de esa materia prima principal se hace una búsqueda de los perfiles disponibles
      rawMatName: "",
      profileNameByImg: "",
      rawMatId: 0,
      avilableProfiles: [],
      //Selecinar tipo de perfil requerida y con los parámetros profilePresnetation y profileSpecification realizar búsqueda
      profilePresentation: "",
      profileSpecification: "",
      profileKiloPrice: 0,
      //Select 2
      //Nombres comerciales disponibles para el perfil seleccionado
      profileTypesByTradeName: [],
      profileFinalId: 0,
      //Etiquetas para espesor y espesor de ala
      widthLabel: "",
      heigthLabel: "",
      thicknessLabel: "",
      flagNoneThicknessLabel: false,
      //Informacion del perfil seleccioando
      profileTypeInfo: [],
      technicalName: "",
      heigthValue: 0,
      widthValue: 0,
      thicknessValue: 0,
      thicknessWingValue: 0,
      weightMeterValue: 0,
    }
  },
  methods: {
    validateRawMatName(rawName) {
      if (rawName === "CANAL_U") {
        this.rawMatId = 5;
        return true;
      } else if (rawName === "VIGA_I") {
        this.rawMatId = 6;
        return true;
      } else if (rawName === "VIGA_H") {
        this.rawMatId = 7;
        return true;
      } else if (rawName === "ANGULO") {
        this.rawMatId = 8;
        return true;
      } else {
        this.rawMatId = 0;
        return false;
      }
    },
    getParameters(option) {
      //console.log(option);
      if (option != "") {
        const parts = option.split(" / ");
        this.profilePresentation = parts[0].trim();
        this.profileSpecification = parts[1].trim();
        //console.log(this.profilePresentation);
        //console.log(this.profileSpecification);
      } else {
        alert("Por favor, sleccione una opcion válida");
      }
      this.searchProfilesByParameters();
    },
    async searchProfilesByParameters() {
      if (this.profilePresentation === "" || this.profileSpecification === "") {
        console.log("Materia prima no selecionada");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/profile/list", {
            params: {
              profile_name: this.profilePresentation,
              profile_specification: this.profileSpecification,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            //console.log(res.data[0]);
            this.heigthLabel = res.data[0].heigthLabel;
            this.widthLabel = res.data[0].widthLabel;
            res.data[0].thicknessLabel == "no_aplica" ? this.flagNoneThicknessLabel = true : this.thicknessLabel = res.data[0].thicknessLabel;
            this.profileKiloPrice = res.data[0].priceId["value"];
            this.$emit("sendKiloPrice", this.profileKiloPrice);
            const profileTypes = res.data[0].profileTypes;
            // Crear un nuevo array clave-valor (id, nombreComercial)
            this.profileTypesByTradeName = profileTypes.map((profileType) => {
              return {
                profile_id: profileType.id,
                profile_trade_name: profileType.tradeName,
                // Puedes agregar más propiedades según sea necesario
              };
            });
            // Mostrar el nuevo array en la consola
            //console.log(this.profileTypesByTradeName);
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    getProfileId(option) {
      // console.log("Profile Id Type: " + option);
      this.profileFinalId = option;
      this.getInfoProfileType();
    },
    async getInfoProfileType() {
      if (this.profileFinalId == 0) {
        console.log("Perfil no selecionado");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/profile/type/get", {
            params: {
              profile_type_id: this.profileFinalId,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            this.profileTypeInfo = res.data[0];
            // console.log(this.profileTypeInfo);
            this.technicalName = this.profileTypeInfo.technicalName;
            this.heigthValue = this.profileTypeInfo.height;
            this.widthValue = this.profileTypeInfo.width;
            this.thicknessValue = this.profileTypeInfo.thickness;
            this.thicknessWingValue = this.profileTypeInfo.thicknessWing;
            this.weightMeterValue = this.profileTypeInfo.weightMeter;
            this.$emit("sendMainProfileTypeIdAndWeigthMeter", { profileTypeId: this.profileFinalId, weightMeter: this.weightMeterValue });
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    defineProfileNameByImg() {
      this.profileNameByImg = this.getImgInfo.imgFormName;
      // console.log(this.profileNameByImg);
      let profileUpperImgName = this.profileNameByImg.toUpperCase();
      //console.log(profileUpperImgName);
      if (this.validateRawMatName(this.rawMatName) && profileUpperImgName != "") {
        //console.log("Id de mat:" + this.rawMatId);
        if (this.rawMatId === 8) {
          axios
            .get(RUTA_SERVIDOR + "api/profile/list", {
              params: {
                profile_raw_material: this.rawMatId,
              },
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            //.then((res) => (console.log(res.data)))
            .then((res) => {
              //console.log(res.data[0]);
              // Aquí colocas el código para eliminar los valores repetidos
              const uniqueProfiles = new Set();
              res.data.forEach((avilableProfile) => {
                // Reemplazar "/" por "-"
                //const specificationText = aviableProfile.specification.replace(/\//g, "-");
                const profileText = `${avilableProfile.name} / ${avilableProfile.specification}`;
                uniqueProfiles.add(profileText);
              });
              this.avilableProfiles = Array.from(uniqueProfiles);
            })
            .catch((err) => console.log(`There has been an error ${err}`));
        } else {
          //console.log("Id de mat:" + this.rawMatId);
          axios
            .get(RUTA_SERVIDOR + "api/profile/list", {
              params: {
                profile_name: profileUpperImgName,
                profile_raw_material: this.rawMatId,
              },
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            //.then((res) => (console.log(res.data)))
            .then((res) => {
              //console.log(res.data[0]);
              // Aquí colocas el código para eliminar los valores repetidos
              const uniqueProfiles = new Set();
              res.data.forEach((avilableProfile) => {
                // Reemplazar "/" por "-"
                //const specificationText = aviableProfile.specification.replace(/\//g, "-");
                const profileText = `${avilableProfile.name} / ${avilableProfile.specification}`;
                uniqueProfiles.add(profileText);
              });
              this.avilableProfiles = Array.from(uniqueProfiles);
            })
            .catch((err) => console.log(`There has been an error ${err}`));
        }
      } else {
        console.log("Nombre de familia no válido");
      }
    },
  },
  mounted() {
    this.rawMatName = this.$store.getters.getRawMatFamily;
    //console.log(this.rawMatName);
  },
};
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.avilable-input {
  background-color: #FCE196;
}
</style>